import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WindowService {
  constructor() {
    window.addEventListener('beforeunload', () => {
      this.clearSessionStorage.bind(this);
      sessionStorage.setItem('refresh_sessionId', this.getSessionIdFromWindow());
    });
  }

  public getSessionIdFromWindow() {
    return window.SessionId ? window.SessionId : '';
  }

  public setSessionIdToWindow(sessionId: string) {
    window.SessionId = sessionId;
  }

  public clearSessionIdFromWindow() {
    return (window.SessionId = null);
  }

  public clearSessionStorage() {
    sessionStorage.clear();
  }

  //TODO: Add Reload Event listener here and handle, clear it here for v2
}
